import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { ftpConnectionInitialValue } from 'components/organisms/forms/ftp-connection/FtpConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostProviderFtpConnection } from 'services/providers/ftp';
import { IProviderFtpConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateFtpConnection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const createFtpConnection = usePostProviderFtpConnection();
  const mutateOptions = useMutateOptions<IProviderFtpConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/ftp-connection/${salesChannelId}/keys`
    );

  const onCreateSale = async (
    values: IProviderFtpConnectionResponse,
    helpers: FormikHelpers<IProviderFtpConnectionResponse>
  ) => {
    await createFtpConnection.mutateAsync(
      { ...values, providerId, salesChannelId },
      {
        ...mutateOptions(helpers),
        onSuccess: () => onGoToDetail(),
      }
    );
  };

  return (
    <Form.FtpConnection
      i18nextPrefix='ftp-connection'
      onSubmit={onCreateSale}
      initialValues={ftpConnectionInitialValue}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => navigate(`/settings/provider/${providerId}`)}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
    />
  );
};

export default CreateFtpConnection;
